import React from 'react'
import { AppBar, Toolbar, IconButton, Box, useTheme as useMuiTheme, Tooltip, Menu as MuiMenu, MenuItem } from '@mui/material'
import { Menu, DarkMode, LightMode, SettingsBrightness } from '@mui/icons-material'
import ToggleButton from '@mui/material/ToggleButton'
import UserProfile from '../Auth/UserProfile'
import { useTheme } from '../../context/ThemeContext'

const Navbar = ({ onDrawerToggle }) => {
  const theme = useMuiTheme()
  const { isDarkMode, toggleTheme, themeSource, resetToSystemTheme, systemPrefersDark } = useTheme()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSystemTheme = () => {
    resetToSystemTheme()
    handleClose()
  }

  return (
    <AppBar
      position='fixed'
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        zIndex: theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 56, sm: 64 },
          px: { xs: 1.5, sm: 2 },
          gap: { xs: 1, sm: 2 },
          justifyContent: 'space-between',
          maxWidth: '100%',
          overflowX: 'hidden',
        }}
      >
        <IconButton
          color='primary'
          aria-label='open drawer'
          edge='end'
          onClick={onDrawerToggle}
          sx={{
            display: { xs: 'block', md: 'none' },
            p: { xs: 0.5, sm: 1.5 },
            '& .MuiSvgIcon-root': {
              fontSize: { xs: '1.5rem', sm: '2rem' },
            },
          }}
        >
          <Menu />
        </IconButton>
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none',
          }}
        >
          <Box
            component='img'
            src='/logo blackda 500x200.png'
            alt='Logo'
            sx={{
              height: { xs: 30, sm: 40 },
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title={themeSource === 'system' ? 'Using system theme' : 'Using custom theme'}>
            <ToggleButton
              value='check'
              selected={isDarkMode}
              onClick={handleClick}
              size='small'
              sx={{
                border: 'none',
                borderRadius: '50%',
                p: { xs: 1, sm: 1.25 },
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-selected': {
                  backgroundColor: 'transparent',
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                  },
                },
                '& .MuiSvgIcon-root': {
                  fontSize: { xs: '1.25rem', sm: '1.5rem' },
                  color: theme.palette.primary.main,
                  transition: 'transform 0.3s ease-in-out',
                  transform: isDarkMode ? 'rotate(360deg)' : 'rotate(0deg)',
                },
              }}
            >
              {isDarkMode ? <DarkMode /> : <LightMode />}
            </ToggleButton>
          </Tooltip>
          <MuiMenu
            id='theme-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'theme-button',
            }}
          >
            <MenuItem onClick={toggleTheme} selected={themeSource === 'user'} sx={{ gap: 1 }}>
              {isDarkMode ? <LightMode fontSize='small' /> : <DarkMode fontSize='small' />}
              {isDarkMode ? 'Light theme' : 'Dark theme'}
            </MenuItem>
            <MenuItem onClick={handleSystemTheme} selected={themeSource === 'system'} sx={{ gap: 1 }}>
              <SettingsBrightness fontSize='small' />
              System theme ({systemPrefersDark ? 'dark' : 'light'})
            </MenuItem>
          </MuiMenu>
          <UserProfile />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Navbar
